import React from 'react';
import config from '../../preorder/configs/config';

export default () => (
  <>
    <img src={`${config.RESOURCE_URI}MenuAd/230402_A5DM_美味假期_1.jpg`} alt="" width="100%" />
    <img src={`${config.RESOURCE_URI}MenuAd/230402_A5DM_美味假期_2.jpg`} alt="" width="100%" />
  </>
);
